import { Map } from 'immutable'
import { createSelector } from 'reselect'

import { selectEmrConfig } from 'selectors/selectEmrConfig'

export const selectJobsConfig = createSelector(
  [selectEmrConfig],
  (emrConfig) => emrConfig.get('spark_jobs') || new Map()
)
